  <template>
  <div style="font-size: 0.9rem; line-height: 1.1; margin-bottom: 10px">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div style="display: flex; align-items: center; gap: 0.3rem">
        <span>{{ getFlag(pais.nombre) }}</span>
        <span>{{ pais.nombre }}</span>
      </div>

      <div>
        {{ modo === "dinero" ? "£" : "" }}{{ formatearValor(pais.actual) }}
        <small v-if="modo === 'cantidad'" style="font-weight: 400">
          pedidos</small
        >
      </div>
    </div>

    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        Año anterior:
        <strong
          >{{ modo === "dinero" ? "£" : ""
          }}{{ formatearValor(pais.promedio) }}</strong
        >
      </div>
      <div
        :style="{
          color:
            pais.diferencia > 0
              ? 'green'
              : pais.diferencia >= -20
              ? 'orange'
              : 'red',
          fontWeight: '700',
        }"
      >
        <template v-if="pais.diferencia > 0">
          ▲ +{{ pais.diferencia.toFixed(1) }}%
        </template>
        <template v-else-if="pais.diferencia >= -20">
          ▶ {{ pais.diferencia.toFixed(1) }}%
        </template>
        <template v-else> ▼ {{ pais.diferencia.toFixed(1) }}% </template>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    pais: {
      type: Object,
      required: true,
    },
    modo: {
      type: String,
      default: "cantidad", // puede ser 'cantidad' o 'dinero'
    },
  },
  computed: {
    borderColorClass() {
      if (this.pais.diferencia > 0) return "border-success";
      if (this.pais.diferencia >= -20) return "border-warning";
      return "border-danger";
    },
  },
  methods: {
    getFlag(pais) {
      const flags = {
        "United States": "🇺🇸",
        "United Kingdom": "🇬🇧",
        Germany: "🇩🇪",
        Italy: "🇮🇹",
        France: "🇫🇷",
        Spain: "🇪🇸",
      };
      return flags[pais] || "🏳️";
    },
    formatearValor(valor) {
      if (this.modo === "dinero") {
        // formato moneda en libras
        return valor.toLocaleString("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } else {
        // formato cantidad sin decimales
        return Math.round(valor).toLocaleString();
      }
    },
  },
};
</script>
  
  <style scoped>
.earnings-card {
  border-width: 2px !important;
}
</style>
  
  
